import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import StoreLocator from '../store_locator/phase2/store-locator';
import {configureStore} from '../store_locator/data-store';

const mountNode = document.getElementById('store-locator-yodel');
const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    {
      <StoreLocator
        postcode={mountNode.dataset.postcode}
        imagesEnabled={mountNode.dataset.imagesEnabled === 'true'}
        isMobileDevice={mountNode.dataset.isMobileDevice === 'true'}
        isInPostEnabled={mountNode.dataset.isInPostEnabled === 'true'}
        isInPostStoreLocatorRebrandEnabled={mountNode.dataset.isInPostStoreLocatorRebrandEnabled === 'true'}
        useOsm={mountNode.dataset.useOsm === 'true'}
        osmUrl={mountNode.dataset.osmUrl}
        defaultZoom={parseInt(mountNode.dataset.defaultZoom, 10) || 6}
        minVisibleStoresMobile={parseInt(mountNode.dataset.minVisibleStoresMobile, 10) || 2}
        minVisibleStoresDesktop={parseInt(mountNode.dataset.minVisibleStoresDesktop, 10) || 5}
        maxRadiusDesktop={parseFloat(mountNode.dataset.maxRadiusDesktop)}
        maxRadiusMobile={parseFloat(mountNode.dataset.maxRadiusMobile)}
        searchFilter={mountNode.dataset.searchFilter}
      />
    }
  </Provider>,
  mountNode
);
